import Cookies from 'js-cookie'

const TOKEN_COOKIE_KEY = 'token-portal-metarh'
const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENV === 'production'

export const setAuthToken = (token: string, expiresDays: number = 7) => {
  Cookies.set(TOKEN_COOKIE_KEY, token, {
    expires: expiresDays,
    path: '/',
    secure: true,
    sameSite: IS_PRODUCTION ? 'None' : 'Lax',
  })
}

export const getAuthToken = () => {
  return Cookies.get(TOKEN_COOKIE_KEY)
}

export const removeAuthToken = () => {
  Cookies.remove(TOKEN_COOKIE_KEY)
}

/**
 * Define o valor de visualização do alerta no cookie
 */
export const setViewAlerta = (cookie: string, view: boolean): void => {
  Cookies.set(cookie, String(view), {
    expires: 1, // expira em 1 dia
    path: '/',
    secure: true,
    sameSite: IS_PRODUCTION ? 'None' : 'Lax',
  })
}

/**
 * Retorna se o alerta já foi visualizado
 */
export const getViewAlerta = (cookie: string): string => {
  const value = Cookies.get(cookie)
  return String(value)
}

/**
 * Verifica se o cookie expirou ou não existe
 */
export const isExpiredAlerta = (cookie: string): boolean => {
  const value = Cookies.get(cookie)
  return !value
}
